const VALIDATOR_TYPE_REQUIRE = "REQUIRE";
const VALIDATOR_TYPE_MINLENGTH = "MINLENGTH";
const VALIDATOR_TYPE_MAXLENGTH = "MAXLENGTH";
const VALIDATOR_TYPE_MIN = "MIN";
const VALIDATOR_TYPE_MAX = "MAX";
const VALIDATOR_TYPE_EMAIL = "EMAIL";
const VALIDATOR_TYPE_FILE = "FILE";
const VALIDATOR_TYPE_CONFIRMPASS = "CONFIRM";
export const VALIDATOR_REQUIRE = () => ({ type: VALIDATOR_TYPE_REQUIRE });
export const VALIDATOR_FILE = () => ({ type: VALIDATOR_TYPE_FILE });
export const VALIDATOR_MINLENGTH = (val) => ({
  type: VALIDATOR_TYPE_MINLENGTH,
  val: val,
});
export const VALIDATOR_MAXLENGTH = (val) => ({
  type: VALIDATOR_TYPE_MAXLENGTH,
  val: val,
});
export const VALIDATOR_MIN = (val) => ({ type: VALIDATOR_TYPE_MIN, val: val });
export const VALIDATOR_MAX = (val) => ({ type: VALIDATOR_TYPE_MAX, val: val });
export const VALIDATOR_EMAIL = () => ({ type: VALIDATOR_TYPE_EMAIL, });
// Function to create the new validator
export const VALIDATOR_EMAIL_OR_PHONE = () => ({ type: VALIDATOR_TYPE_EMAIL_OR_PHONE });
export const VALIDATOR_CONFIRMPASS = (val) => ({
  type: VALIDATOR_TYPE_CONFIRMPASS,
  val: val,
});

const VALIDATOR_TYPE_EMAIL_OR_PHONE = "EMAIL_OR_PHONE";

// Regular expression for email and phone number validation
const EMAIL_REGEX = /^\S+@\S+\.com$/;
const PHONE_REGEX = /^(\+88|0088)?(01){1}[3456789]{1}(\d){8}$/;


export const validate = (value, validators) => {
  let isValid = true;
  for (const validator of validators) {
    if (validator.type === VALIDATOR_TYPE_REQUIRE) {
      isValid = isValid && value.trim().length > 0;
    }
    if (validator.type === VALIDATOR_TYPE_MINLENGTH) {
      isValid = isValid && value.trim().length >= validator.val;
    }
    if (validator.type === VALIDATOR_TYPE_MAXLENGTH) {
      isValid = isValid && value.trim().length <= validator.val;
    }
    if (validator.type === VALIDATOR_TYPE_MIN) {
      isValid = isValid && +value >= validator.val;
    }
    if (validator.type === VALIDATOR_TYPE_MAX) {
      isValid = isValid && +value <= validator.val;
    }
    if (validator.type === VALIDATOR_TYPE_EMAIL) {
      isValid = isValid && /^\S+@\S+\.\S+$/.test(value);
    }
    if (validator.type === VALIDATOR_TYPE_CONFIRMPASS) {
      isValid = isValid && value === validator.val;
    }
    if (validator.type === VALIDATOR_TYPE_EMAIL_OR_PHONE) {
      isValid = isValid && (EMAIL_REGEX.test(value) || PHONE_REGEX.test(value));
    }
  }
  return isValid;
};
